import { config } from "../../config"
import { Review } from "./data-types"

export const getBookReviews = async (bookId: number, offset: number, limit: number, token?: string): Promise<Review[]> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
      authHeaders['token'] = token!
  }

  const res = await fetch(`${config.api.urlV1}/book/reviews/?book_id=${bookId}&limit=${limit}&offset=${offset}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("error fetching book reviews")
  }

  const reviews = (await res.json()).data

  return reviews
}

export const getProfileReviews = async (publicId: string, offset: number, limit: number, token?: string): Promise<Review[]> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
      authHeaders['token'] = token!
  }

  const res = await fetch(`${config.api.urlV1}/book/reviews/?user_id=${publicId}&limit=${limit}&offset=${offset}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("error fetching user reviews")
  }

  const reviews = (await res.json()).data

  return reviews
}

export const getSingleReview = async (reviewId: number, token?: string): Promise<Review> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
      authHeaders['token'] = token!
  }

  const res = await fetch(`${config.api.urlV1}/book/reviews/${reviewId}/`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("error fetching user reviews")
  }

  const review = await res.json()

  return review
}

export const createReview = async (bookId: number, newReview: Partial<Review>, token: string): Promise<Review> => {
  const res = await fetch(`${config.api.urlV1}/book/reviews/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      token,
    },
    body: JSON.stringify({
      book_id: bookId,
      ...newReview,
    })
  })

  if (res.status !== 200) {
    throw new Error("error fetching user reviews")
  }

  const review = await res.json()

  return review
}

export const updateReview = async (reviewId: number, newReview: Partial<Review>, token: string): Promise<Review> => {
  const res = await fetch(`${config.api.urlV1}/book/reviews/${reviewId}`, {
    method: "PATCH",
    headers: {
      "Content-type": "application/json",
      token,
    },
    body: JSON.stringify(newReview)
  })

  if (res.status !== 200) {
    throw new Error("error updating user review")
  }

  const review = await res.json()

  return review
}

export const changeRating = async (bookId: number, rating: number, token: string): Promise<void> => {
  const res = await fetch(`${config.api.urlV1}/book/rating/?book_id=${bookId}`, {
    method: "PATCH",
    headers: {
      "Content-type": "application/json",
      token,
    },
    body: JSON.stringify({
      rating
    })
  })

  if (res.status !== 200) {
    throw new Error("error fetching user reviews")
  }
}
